import { render, staticRenderFns } from "./GraficoDona.vue?vue&type=template&id=650388a0&"
import script from "./GraficoDona.vue?vue&type=script&lang=js&"
export * from "./GraficoDona.vue?vue&type=script&lang=js&"
import style0 from "./GraficoDona.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650388a0')) {
      api.createRecord('650388a0', component.options)
    } else {
      api.reload('650388a0', component.options)
    }
    module.hot.accept("./GraficoDona.vue?vue&type=template&id=650388a0&", function () {
      api.rerender('650388a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/generic/GraficoDona.vue"
export default component.exports